import { useDispatch } from "react-redux";
import { clearCompleted } from "../redux/todos/actions";

export default function CompletedHeader() {
    const dispatch = useDispatch();
    // const { todos, filters: { colors } } = useSelector((state) => state);

    const clearHeandler = () => {
        dispatch(clearCompleted());
    };

    // const filterByStatusAndColor = () => {
    //     return todos.filter(todo => {
    //         if (todo.completed) return false
    //         if (colors.length === 0) return true
    //         return colors.includes(todo?.color);
    //     })
    // }

    return (
        <div>
            <h1 className="bg-gray-100 px-4 py-4">Completed Tasks</h1>
            <ul className="flex justify-between my-4 text-xs text-gray-500">
                <li className="cursor-pointer" onClick={clearHeandler}>
                    Clear completed
                </li>
            </ul>
        </div>
    );
}
